import styled from 'styled-components';
import {theme} from '@styles/theme';

export const ProfilePageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ProfileContentWrapper = styled.div`
  width: calc(100% - 48px);
  height: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ProfileInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const ProfileInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ProfileAvatarWrapper = styled.div`
  width: 128px;
  height: 128px;
  border: 3px solid ${theme.colors.basic06};
  border-radius: 128px;
  padding: 11px;
  position: relative;
  img {
    object-fit: cover;
    object-position: center;
    display: block;
    border-radius: 128px;
  }

  div {
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.basic06};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 128px;
  }
`;

export const AvatarEditButton = styled.button`
  position: absolute;
  right: 5px;
  top: 5px;
  width: 32px;
  height: 32px;
  border-radius: 28px;
  border: 0;
  background: ${theme.colors.basic07};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ProfileInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ProfileEditInputWrapper = styled.div`
  cursor: pointer;
`;

export const ProfileButtonsWrapper = styled.div`
  margin-top: auto;
  padding: 24px 0 0 24px;
  width: calc(100% + 24px);
  margin-left: -24px;
  border-top: 1px solid ${theme.colors.basic06};
`;
